import { Button, Input, Form, Row, Col, Select, Card, Checkbox, message } from 'antd';
import { useEffect, useState } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'
import commonLookupService from 'src/services/commonLookupService';
import service from '../../../../src/services/citizenscienceService';
import { recordError } from 'src/utils/logService';
import util from 'src/utils/functions/custom';
import { ContactField } from "../../custom/ContactField";
import { Messages, Notify } from 'src/services/custom/Messages';
import { openNotification, ActivityIndicator } from '@seims/shared';

import { LoadCanvasTemplate, loadCaptchaEnginge, validateCaptcha } from "react-simple-captcha"

export default function JoinProject() {

    const [titles, setTitles] = useState([])
    const [gender, setGender] = useState([])
    const [race, setRace] = useState([]);
    const [ageGroup, setAgeGroup] = useState([]);
    const [disability, setDisability] = useState([]);
    const [participants, setParticipants] = useState([]);

    const [provinces, setProvinces] = useState([]);
    const [province, setProvince] = useState();
    const [district, setDistrict] = useState();
    const [town, setTown] = useState();
    const [districts, setDistricts] = useState([]);
    const [towns, setTowns] = useState([]);
    const [captcha, setCaptcha] = useState(false);
    const [submitted, setSubmitted] = useState(false);

    const [error, setError] = useState('')
    const [captchaValue, setCaptchaValue] = useState()

    const [motivations, setMotivations] = useState([])

    // const [loading, setLoading] = useState([]);

    let navigate = useNavigate();
    const { state } = useLocation();

    useEffect(() => {
        getTitles();
        getGenders();
        getRaces();
        getDisability();
        getAgeGroups();
        getprovinceData();
        getParticipantTypes();
        getParticipantsMotivations();
        loadCaptchaEnginge(6, '#1569C7')
    }, [])
    const { Option } = Select;
    const [form] = Form.useForm();
    const formName = "JoinProject";

    const handleBackHome = () => {
        navigate('/citisci')
    };

    if (state === null) {
        handleBackHome();
    };

    const validateCaptchaValue = (e) => {
        setError("")
        if (validateCaptcha(captchaValue) === true) {
            setError(<p style={{ color: "green" }}>Captcha is valid</p>)
            setCaptcha(true)
        } else {
            setError(<p style={{ color: "red" }}>Captcha is invalid</p>)
            setCaptcha(false)
        }
    };

    const onFinish = async (values) => {

        let msg;
        let action = "Join Request";
        if (captcha === true) {

            const data = {
                title: values.title,
                firstname: values.firstname,
                lastname: values.lastname,
                contactNumber: values.contactNumber,
                email: values.emailAddress,
                disability: values.disability,
                gender: values.gender,
                race: values.race,
                ageGroup: values.ageGroup,
                type: values.participants,
                motivations: values.motivation,
                location: {
                    province: values.province,
                    district: values.district,
                    town: values.town
                }
            }

            try {
                setSubmitted(true);

                const response = await service.addParticipantData({ data: data, projectId: state?.uuid });
                setSubmitted(false);
                if (response.status === 200 || response.status === 201) {
                    msg = util.parseMessage(Messages.JOIN_SUCCESS);
                    openNotification(action, msg, Notify.SUCCESS);
                    // redirect back home
                    handleBackHome();
                } else {
                    msg = util.parseMessage(Messages.ADD_FAILURE);
                    openNotification(action, msg, Notify.ERROR);
                }
            } catch (error) {
                msg = (error.response.status === 409) ? "Your request to join the project has already been received. You will receive an email if there is any update" : util.parseMessage("Your join request was unsuccessfull, please verify that the form is complete");
                openNotification(action, msg, Notify.ERROR);

                recordError(error);
            }
        } else {
            msg = util.parseMessage(Messages.INVALID_CAPTCHA);
            openNotification("Captcha Validation", msg, Notify.ERROR);

        }
        setSubmitted(false);
    };

    const getTitles = async () => {
        try {
            const response = await commonLookupService.getTitles();
            if (response) {
                const { data } = response;
                setTitles(data);
            }
        } catch (error) {
            recordError(error);
        }
    };

    const getDisability = async () => {
        try {
            const response = await commonLookupService.getDisability();
            if (response) {
                const { data } = response;
                setDisability(data);
            }
        } catch (error) {
            recordError(error);
        }
    };

    const getGenders = async () => {
        try {
            const response = await commonLookupService.getGenders();
            if (response) {
                const { data } = response;
                setGender(data);
            }
        } catch (error) {
            recordError(error);
        }
    };

    const getRaces = async () => {
        try {
            const response = await commonLookupService.getRaces();
            if (response) {
                const { data } = response;
                setRace(data);
            }
        } catch (error) {
            recordError(error);
        }
    };

    const getprovinceData = async () => {
        try {
            const response = await commonLookupService.getProvincesDistrictTowns();
            if (response && response.status === 200) {
                const { data } = response;
                setProvinces(data);
            }
        } catch (error) {
            recordError(error);
        }
    };

    const getParticipantTypes = async () => {
        try {
            const response = await commonLookupService.getParticipantTypes();
            if (response) {
                const { data } = response;
                setParticipants(data);
            }
        } catch (error) {
            recordError(error);
        }
    };

    const getAgeGroups = async () => {
        try {
            const response = await commonLookupService.getAgeGroup();
            if (response) {
                const { data } = response;
                setAgeGroup(data);
            }
        } catch (error) {
            recordError(error);
        }
    };

    const getParticipantsMotivations = async () => {
        try {
              const response = await commonLookupService.getParticipantsMotivations();
              if (response && response.status === 200) {
                const { data } = response;
                const transformData = data.map((c) => ({
                  label: c.value,
                  value: c.key,
                  key: c.key,
                }));
                setMotivations(transformData);
              }
        } catch (error) {
            recordError(error);
        }
    };

    const handleContactChange = (value) => {
        if (value === 0 || value.length < 10) {
            form.setFieldsValue({ contactNumber: undefined });
            return;
        }
        form.setFieldsValue({ contactNumber: value });
    };

    const handleProvinceChange = (value) => {
        setProvince(value)
        setDistricts(provinces.find(prov => prov.key == value).districts)
    };

    const handleDistrictChange = (value) => {
        setDistrict(value)
        setTowns(districts.find(district => district.key == value).towns)
    };

    const handleCityChange = (value) => {
        setTown(value)
    };

    const onEmailBlur = (e)=> {
        const updatedValue = e.target.value.trim();
        form.setFieldsValue({emailAddress: updatedValue})
    }

    return (
        <div className='join-background' >
            <Col xs={24}>
                <div className="public-portal-section">
                    <h2>Citizen Science - Join Project</h2>
                </div>
            </Col>
            <Card className='join-project-card'>
                <div style={{ fontSize: 18, color: "#0B4A7C" }}>{"Project Name: " + state?.name}</div>
                <Form
                    name={formName}
                    form={form}
                    layout="vertical"
                    onFinish={onFinish}
                >
                    <h2>Your Information</h2>
                    <Row gutter={{ xs: 2, md: 20 }}>
                        <Col xs={24} md={6}>
                            <Form.Item label="Title" name="title"
                                rules={[
                                    {
                                        required: true,
                                        message: "Title is required",
                                    }
                                ]}
                            >
                                <Select >
                                    {titles.map((title) => (
                                        <Option key={title.key}> {title.value}</Option>
                                    ))}
                                </Select>
                            </Form.Item>
                        </Col>
                        <Col xs={24} md={6}>
                            <Form.Item label="Name" name={"firstname"}
                                rules={[
                                    {
                                        required: true,
                                        message: "Name is required",
                                    }
                                ]}
                            >
                                <Input name='firstname' />
                            </Form.Item>
                        </Col>
                        <Col xs={24} md={6} >
                            <Form.Item label="Surname" name={"lastname"}
                                rules={[
                                    {
                                        required: true,
                                        message: "Surname is required",
                                    }
                                ]}
                            >
                                <Input name='lastname' />
                            </Form.Item>
                        </Col>
                    </Row>
                    <Row gutter={{ xs: 2, md: 20 }}>
                        <Col xs={24} md={6}>
                            <Form.Item label="Cellphone Number" name="contactNumber"
                                rules={[
                                    { required: true, message: "Please enter your contact number" },
                                    {
                                        min: 10,
                                        message: "Contact length expects 10 numeric values",
                                    },
                                ]}
                            >
                                <ContactField onContactChange={handleContactChange}
                                />
                            </Form.Item>
                        </Col>
                        <Col xs={24} md={6}>
                            <Form.Item label="Email Address" name={"emailAddress"}
                                rules={[
                                    {
                                        type: "email",
                                        message: "The input is not valid E-mail",
                                    },
                                    {
                                        required: true,
                                        message: "Please enter your E-mail",
                                    },
                                ]}
                            >
                                <Input name='email' onBlur={onEmailBlur} />
                            </Form.Item>
                        </Col>
                    </Row>
                    <Row gutter={{ xs: 2, md: 20 }}>
                        <Col xs={24} md={6}>
                            <Form.Item label="Disability" name={"disability"}
                                rules={[
                                    {
                                        required: true,
                                        message: "Disability is required",
                                    }
                                ]}
                            >
                                <Select>
                                    {disability.map((disa) => (
                                        <Option key={disa.key}> {disa.value}</Option>
                                    ))}
                                </Select>
                            </Form.Item>
                        </Col>
                        <Col xs={24} md={6}>
                            <Form.Item label="Gender" name={"gender"}
                                rules={[
                                    {
                                        required: true,
                                        message: "Gender is required",
                                    }
                                ]}
                            >
                                <Select>
                                    {gender.map((gen) => (
                                        <Option key={gen.key}> {gen.value}</Option>
                                    ))}
                                </Select>
                            </Form.Item>
                        </Col>
                        <Col xs={24} md={6}>
                            <Form.Item label="Race" name={"race"}
                                rules={[
                                    {
                                        required: true,
                                        message: "Race is required",
                                    }
                                ]}
                            >
                                <Select >
                                    {race.map((rac) => (
                                        <Option key={rac.key}> {rac.value}</Option>
                                    ))}
                                </Select>
                            </Form.Item>
                        </Col>
                    </Row>
                    <Row gutter={{ xs: 2, md: 20 }}>
                        <Col xs={24} md={6}>
                            <Form.Item label="Age Group" name={"ageGroup"}
                                rules={[
                                    {
                                        required: true,
                                        message: "Age range is required",
                                    }
                                ]}
                            >
                                <Select >
                                    {ageGroup.map((age) => (
                                        <Option key={age.key}> {age.value}</Option>
                                    ))}
                                </Select>
                            </Form.Item>
                        </Col>
                        <Col xs={24} md={6}>
                            <Form.Item label="Participants Type" name={"participants"}
                                rules={[
                                    {
                                        required: true,
                                        message: "Public type is required",
                                    }
                                ]}
                            >
                                <Select>
                                    {participants.map((part) => (
                                        <Option key={part.key}> {part.value}</Option>
                                    ))}
                                </Select>
                            </Form.Item>
                        </Col>
                    </Row>

                    <Card title="Location">
                        <Form.Item name="address" >
                            <Row gutter={{ xs: 2, md: 20 }}>
                                <Col xs={24} md={6}>
                                    <Form.Item
                                        // {...restField}
                                        name={'province'}
                                        label="Province"
                                        rules={[
                                            {
                                                required: true,
                                                message: 'Please select Province',
                                            },
                                        ]}
                                    >
                                        <Select value={province} onChange={handleProvinceChange}>
                                            {provinces?.map(option => (
                                                <Option key={option.key}>{option.value}</Option>
                                            ))}
                                        </Select>
                                    </Form.Item>
                                </Col>

                                <Col xs={24} md={6}>
                                    <Form.Item
                                        // {...restField}
                                        name={'district'}
                                        label="District"
                                        rules={[
                                            {
                                                required: true,
                                                message: 'Please select District',
                                            },
                                        ]}
                                    >
                                        <Select value={district} onChange={handleDistrictChange}>
                                            {districts?.map(dist => (
                                                <Option key={dist.key}>{dist.value}</Option>
                                            ))}
                                        </Select>
                                    </Form.Item>
                                </Col>
                                <Col xs={24} md={6}>
                                    <Form.Item
                                        // {...restField}
                                        name={'town'}
                                        label="Nearest Town"
                                        rules={[
                                            {
                                                required: false,
                                                message: 'Please select nearest City/Town',
                                            },
                                        ]}
                                    >
                                        <Select value={town} onChange={handleCityChange}>
                                            {towns?.map(town => (
                                                <Option key={town.key}>{town.value}</Option>
                                            ))}
                                        </Select>
                                    </Form.Item>
                                </Col>
                            </Row>
                        </Form.Item>
                    </Card>
                    <br />
                    <Row>
                        <Col xs={24} md={12}>
                            <Form.Item label="Reason for joining the project " name="motivation"
                                rules={[
                                    {
                                        required: true,
                                        message: "Please select at least one reason for joining the project",
                                    }
                                ]}
                            >
                                <Checkbox.Group
                                    options={motivations}
                                    style={{ display: "flex", flexDirection: "column" }}
                                />
                            </Form.Item>
                        </Col>
                    </Row>
                    <Row>
                        <Col xs={24} md={6}>
                            <Form.Item label="Captcha " name="captchaValue"
                                rules={[
                                    {
                                        required: true,
                                        message: "",
                                    }
                                ]}

                            >
                                <Input type="text" value={captchaValue} onChange={(e) => setCaptchaValue(e.target.value)} />
                            </Form.Item>
                            {error && <p>{error}</p>}
                            <LoadCanvasTemplate />
                        </Col>
                    </Row>
                    <Row justify="end">
                        <Form.Item label="" colon={false}>
                            <Button type="default" onClick={handleBackHome} style={{ marginLeft: 20, borderRadius: "15px" }}>
                                Cancel
                            </Button>
                            
                            <Button
                                htmlType="submit"
                                style={{ marginLeft: 20, borderRadius: "15px", backgroundColor: "#FEEB9D" }}
                                onClick={validateCaptchaValue}
                                loading={submitted}
                            >
                                Submit
                            </Button>
                        </Form.Item>
                    </Row>
                    {/* {(submitted === true) && (
                        <>
                            <hr />
                            <ActivityIndicator visible={true} message={"Submission is progress, please wait...."} />
                        </>
                    )} */}
                </Form>
            </Card >
        </div >
    )
}
